// extracted by mini-css-extract-plugin
export default {"heading":"aboutOverview_heading__jFYeJ","overviewFirstSec":"aboutOverview_overviewFirstSec__iAHkZ","overviewdesc":"aboutOverview_overviewdesc__NEaK2"};